import { Button, Stack, type ButtonProps } from '@mui/material';

interface StepActionsProps {
  onBack?: () => void;
  backLabel?: string;
  onSkip?: () => void;
  skipLabel?: string;
  onNext: () => void;
  nextLabel?: string;
  nextDisabled?: boolean;
  nextLoading?: boolean;
  nextButtonProps?: Partial<ButtonProps>;
}

export const StepActions = ({
  onBack,
  backLabel = 'Voltar',
  onSkip,
  skipLabel = 'Pular etapa',
  onNext,
  nextLabel = 'Continuar',
  nextDisabled,
  nextLoading,
  nextButtonProps,
}: StepActionsProps) => {
  return (
    <Stack
      mt={2}
      direction={{ md: 'row' }}
      justifyContent={onBack ? 'space-between' : 'flex-end'}
    >
      {onBack && <Button onClick={onBack}>{backLabel}</Button>}
      <Stack direction="row" gap={2} sx={{ width: { xs: '100%', md: 'auto' } }}>
        {onSkip && (
          <Button onClick={onSkip} sx={{ width: { xs: '100%', md: 'auto' } }}>
            {skipLabel}
          </Button>
        )}
        <Button
          variant="contained"
          onClick={onNext}
          disabled={nextDisabled}
          loading={nextLoading}
          {...nextButtonProps}
          sx={{ width: { xs: '100%', md: 'auto' } }}
        >
          {nextLabel}
        </Button>
      </Stack>
    </Stack>
  );
};
